import { render, staticRenderFns } from "./PullCertifications.vue?vue&type=template&id=12040a46"
import script from "./PullCertifications.vue?vue&type=script&lang=js"
export * from "./PullCertifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports